module.exports = __webpack_public_path__ + "img/481f9b0211cd7db9aae14fbe1529d816.svg";